import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  CreateScheduleBatchResponse,
  GetScheduleByIdResponse,
  GetScheduledResultsResponse,
} from './types';

export const createScheduleAssistantBatch = (
  params: {
    accountId: string;
    projectId: string;
  },
  payload: {
    schedule_name: string;
    task_id: string;
    cadence: string;
    max_conversations: number;
    query: string;
  },
) => {
  return doPost<CreateScheduleBatchResponse>(
    generateNextPath(ENDPOINTS.SCHEDULED_RESULTS, params),
    LOGGER_TYPE.ANALYTICS,
    payload,
    { prefix: 'nebula' },
  );
};

export const getScheduledResults = (params: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<GetScheduledResultsResponse>(
    generateNextPath(ENDPOINTS.SCHEDULED_RESULTS, params),
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const getScheduledResultById = (params: {
  accountId: string;
  projectId: string;
  schedule_id: string;
  queryParams?: string;
}) => {
  return doGet<GetScheduleByIdResponse>(
    generateNextPath(ENDPOINTS.SCHEDULED_RESULT, params),
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula', query: params.queryParams },
  );
};

export const deleteScheduledResultById = (params: {
  accountId: string;
  projectId: string;
  schedule_id: string;
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.SCHEDULED_RESULT, params),
    LOGGER_TYPE.ANALYTICS,
    {},
    { prefix: 'nebula' },
  );
};
